import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { PaymentStore } from '../../event/service/payment.store';
import { FlashMessagesService } from '../flash-messages/service/flash.messages.service';

@Injectable()
export class FinalPaymentAuthorizedGuard implements CanActivate {

  constructor(
    private paymentStore: PaymentStore,
    private flashMessagesService: FlashMessagesService
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let activate = true;

    this.paymentStore.getLatestFinalPayment().take(1).subscribe(lastFinalPayment => {
      if (Boolean(lastFinalPayment && lastFinalPayment.eventPaymentId
        && !this.paymentStore.isPaymentRequestedOrRequestResent(lastFinalPayment))
        && !this.paymentStore.isPaymentRequestRejected(lastFinalPayment)) {
        this.flashMessagesService.error('MESSAGES.ERROR.UNABLE_TO_NAVIGATE',
          'Cannot edit an event with a final payment already authorized');
        activate = false;
      }
    });

    return activate;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/guards/final-payment-authorized.guard.ts